import { forwardRef, type Ref, type SVGProps } from "react";
const IconChevronDownOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M28.23 11.3 15.94 23.59 3.65 11.31a1 1 0 0 0-1.41 1.41l13 13a1 1 0 0 0 1.42 0l13-13a1 1 0 0 0 0-1.42 1 1 0 0 0-1.43 0"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconChevronDownOutlineSVG);
ForwardRef.displayName = "IconChevronDownOutline";
export { ForwardRef as IconChevronDownOutline };
